import { memo } from 'react'
import './ErrorFallback.less'
import SvgIcon from '@/components/SvgIcon/SvgIcon'
import kefuCode from '@/assets/images/kefuCode.png'
interface ErrorFallbackProps {
  error: unknown
  componentStack?: string
  eventId?: string
  resetError: () => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ErrorFallback = (_props: ErrorFallbackProps) => {
  return (
    <div className='error-fallback'>
      <div className='error-fallback-content'>
        <SvgIcon href={'icon-shengji'} className='error-fallback-icon' />
        <div className='error-fallback-title'>平台正在升级维护中</div>
        <div className='error-fallback-subtitle'>请 1分钟后 刷新浏览器重新进入</div>
        <button className='error-fallback-button' onClick={() => (window.location.href = '/')}>
          返回首页
        </button>
        <img className='error-fallback-image' src={kefuCode} alt='客服二维码' />
        <div className='error-fallback-footer'>若长时间未恢复 请联系客服</div>
      </div>
    </div>
  )
}

export default memo(ErrorFallback)
